import React from 'react';
import PropTypes from 'prop-types';
import { CustomPicker } from 'react-color';
import { Saturation } from 'react-color/lib/components/common';
import classNames from 'classnames';
import InputFields from './components/input-fields';
import Pointer from './components/pointer';
import ColorPattern from './components/color-pattern';
import saturationLayouts from './constants/saturation-layouts';
import Box from '../box';
import Stack from '../stack';
import NotificationMessage from '../notification-message';
import Paragraph from '../paragraph';

const ColorPicker = ({
  notificationTitle = '',
  saturationLayout = saturationLayouts.FULLWIDTH,
  enableAlpha = false,
  alphaTooltipLabel = '',
  onChangeComplete = Function.prototype,
  ...props
}) => (
  <div className="ws-ui-color-picker">
    <Box
      {...(saturationLayout === saturationLayouts.BOXED && {
        paddingLeft: 'spacing-m',
        paddingRight: 'spacing-m',
      })}
    >
      <div
        className={classNames(
          'ws-ui-color-picker__saturation',
          `ws-ui-color-picker__saturation--${saturationLayout}`
        )}
      >
        <Saturation
          {...props}
          onChangeComplete={onChangeComplete}
          pointer={({ hex }) => <Pointer color={hex} />}
        />
      </div>
    </Box>
    <Box
      paddingTop="spacing-s"
      paddingBottom="spacing-s"
      paddingLeft="spacing-m"
      paddingRight="spacing-m"
    >
      <Stack gap="spacing-xs">
        <ColorPattern {...props} enableAlpha={enableAlpha} />
        <Stack gap="spacing-xs">
          <InputFields {...props} enableAlpha={enableAlpha} alphaTooltipLabel={alphaTooltipLabel} />
          {notificationTitle && (
            <NotificationMessage
              appearance="warning"
              iconGlyph="bell"
              title={<Paragraph>{notificationTitle}</Paragraph>}
            />
          )}
        </Stack>
      </Stack>
    </Box>
  </div>
);

ColorPicker.propTypes = {
  notificationTitle: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.object, PropTypes.object, PropTypes.string]).isRequired,
  enableAlpha: PropTypes.bool,
  alphaTooltipLabel: PropTypes.string,
  saturationLayout: PropTypes.oneOf(Object.values(saturationLayouts)),
  onChange: PropTypes.func.isRequired,
  onChangeComplete: PropTypes.func,
};

export default CustomPicker(ColorPicker);
